module.exports = __webpack_public_path__ + "media/img/pages/profile/zhaw ger 6-4be27f178224a50d17908777512ec113.jpg";